interface ComputerWithMeterSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithMeterSVG = ({ color, style }: ComputerWithMeterSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="50"
    viewBox="0 0 45 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_8077)">
      <path
        d="M37.2861 0.591309H4.24492C2.50258 0.591309 1.09814 1.99574 1.09814 3.73809V28.8384C1.09814 30.5808 2.51314 31.9852 4.24492 31.9852H40.2428C41.9852 31.9852 43.3896 30.5702 43.3896 28.8384V3.73809C43.3896 1.99574 41.9746 0.591309 40.2428 0.591309H37.2861Z"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.4565 31.9957L9.53467 36.8532H22.2485H34.9623L33.0299 31.9957"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M40.0312 40.5386L43.7165 47.1806C44.2656 48.1838 43.5475 49.4087 42.4071 49.4087H2.09028C0.949839 49.4087 0.221222 48.1838 0.780884 47.1806L4.46621 40.5386H40.0417H40.0312Z"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.32202 24.2766C5.32202 14.9313 12.9039 7.34949 22.2492 7.34949C31.5945 7.34949 39.1763 14.9313 39.1763 24.2766"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.4394 24.2766C22.4394 24.3822 22.3549 24.4667 22.2493 24.4667C22.1437 24.4667 22.0592 24.3822 22.0592 24.2766C22.0592 24.171 22.1437 24.0865 22.2493 24.0865C22.3549 24.0865 22.4394 24.171 22.4394 24.2766Z"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.8575 24.2766C24.8575 25.7233 23.6853 26.8954 22.2387 26.8954C20.792 26.8954 19.6199 25.7233 19.6199 24.2766C19.6199 22.8299 20.792 21.6578 22.2387 21.6578C22.7667 21.6578 23.263 21.8162 23.6748 22.0907L28.321 15.7655"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.2383 9.37695V11.2988"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.6348 10.1056L18.2261 11.9324"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.4844 12.228L14.6143 13.7697"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M10.1895 15.5227L11.7417 16.642"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.06738 19.6726L9.8942 20.2639"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.33911 24.2766H9.26097"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.1379 24.2766H35.2266"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.4095 19.6726L34.5933 20.2639"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M34.298 15.5227L32.7457 16.642"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.0032 12.228L29.8733 13.7697"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M26.8424 10.1056L26.2511 11.9324"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.9321 24.2766C11.9321 18.5849 16.5467 13.9703 22.2384 13.9703C23.2943 13.9703 24.3186 14.1287 25.2795 14.4244"
        stroke={color}
        strokeWidth="1.18268"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_8077">
        <rect width="44.4879" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithMeterSVG;
